<template>
  <v-form ref="CHECK_RECEIVED" @submit.prevent="sectionSave" lazy-validation class="section">
    <div>
      <section-header v-if="!hideTitle"
                      :ressource="ressource"
                      :isExtended="extended"
                      :dialog="dialog"
                      :picto="picto()"
                      :fiche=fiche
                      :isAbstract=isAbstract
                      @extended=setExtended
                      @closeDialog=closeDialog
                      ref="CHECK_RECEIVED">
      </section-header>
      <div v-if="extended" id="field-container" :class="dialog ? 'p-0 p-md-3' : 'py-2'">
        <etablissement-select v-if="isDisplayed('ETABLISSEMENT_ID')"
                              ref="ETABLISSEMENT_ID"
                              :theme="theme"
                              :showMissing="showMissing"
                              v-model:value=etablissementId
                              :moduleId=moduleId
                              libelle="'Emetteur'"
                              newLabel=''
                              selectText=""
                              @status=statusEtablissementId
                              :requiredAttributs="requiredAttributs"
                              :autoSelect=true
                              :ressource=ressourceEtablissementSelect
                              :filters=etablissementIdFilter
                              :toggleReset=resetEtablissementId
                              :required="isRequired('ETABLISSEMENT_ID')"
                              :contextId=transaction.id
                              :readOnly="readOnly('ETABLISSEMENT_ID')"
                              :objType=objType
                              :fiche=fiche
                              :sectionName="sectionName">
        </etablissement-select>
        <transaction-amount v-if="isDisplayed('AMOUNT')"
                            ref="AMOUNT"
                            :theme="theme"
                            :showMissing="showMissing"
                            v-model:value=amount
                            @status=statusAmount
                            :required="isRequired('AMOUNT')"
                            :contextId=transaction.id
                            :readOnly="readOnly('AMOUNT')"
                            :objType=objType
                            :fiche=fiche
                            :sectionName="sectionName">
        </transaction-amount>
        <transaction-reference v-if="isDisplayed('REFERENCE')"
                               ref="REFERENCE"
                               :theme="theme"
                               :showMissing="showMissing"
                               v-model:value=reference
                               @status=statusReference
                               :over-ride-placeholder=placeholderReference
                               :required="isRequired('REFERENCE')"
                               :contextId=transaction.id
                               :readOnly="readOnly('REFERENCE')"
                               :objType=objType
                               :fiche=fiche
                               :sectionName="sectionName">
        </transaction-reference>
      </div>
    </div>
    <div v-if="extended" class="d-flex flex-row-reverse">
      <loader-button v-if="saveButton"
                     class="ms-2"
                     type="submit"
                     :loading="saveLoading"
                     :label="saveLabel"
                     :disabled="!updatedAndValid">
      </loader-button>
      <div v-for="(button, index) in extraButtons" :key="index">
        <loader-button class="ms-2"
                       :outlined="button.outlined"
                       @callback="button.callback()"
                       :type="button.type"
                       :label="button.label"
                       :loading="button.loading"
                       :disabled="button.disabled">
        </loader-button>
      </div>
    </div>
    <div class="d-flex flex-row-reverse" v-if="saveFailed && saveButton && extended">
      <p class="text-12 text-bold error-text">{{errorTxt}}</p>
    </div>
  </v-form>
</template>

<script lang="ts">
  import { defineComponent } from "vue";
  import CrudTransaction from '@/generated/cruds/CrudTransaction';
  // eslint-disable-next-line
  import { GenControl, GenSection, RessourceGenControl, RessourceGenSection } from '@/generated/ressources/generatedRessources';
  import { FwkButtons, RessourceFwkButton, RessourceFwkSection, FwkSections } from '@/ressources/globalRessources';
  import { Sections } from '@/generated/classes/AppSchema';
  import Button, { ButtonCallback } from '@/framework/base/classes/Button';
  import { ColumnFilter, ListChoix } from '@/extend/classes/ListData';
  import { ObjTypes } from '@/generated/classes/ObjTypes';

  export default defineComponent({
    extends:  CrudTransaction,
    components: {},
    props: {
      hideTitle: {
        type: Boolean,
      },
      isAbstract: {
        type: Boolean,
      },
    },

    data() {
      return {
        sectionName: Sections.CHECK_RECEIVED,
        displayMap: new Map<string, Boolean>,
        readOnlyMap: new Map<string, Boolean>,
        requiredMap: new Map<string, Boolean>,
        placeholderReference: null,
      }
    },

    computed: {
      saveLabel () { 
        return RessourceFwkButton(FwkButtons.ENREGISTRER).label;
      },

      errorTxt () { 
        return RessourceFwkSection(FwkSections.ERROR_TEXT).label;
      },

      ressourceEtablissementSelect () { return RessourceGenControl(GenControl.CHECK_RECEIVED_ETABLISSEMENT_SELECT); },

      ressource () { return RessourceGenSection(GenSection.CHECK_RECEIVED); },

      fields (): string[] {
        return ['ETABLISSEMENT_ID', 'AMOUNT', 'REFERENCE'];
      },

      extraButtons (): Button[] {
        return [];
      },

      etablissementIdFilter (): ColumnFilter[] {
        const res: ColumnFilter[] = [];
        return res;
      },
    },
    methods: {
      getRequiredAttributs(): string[] {
        const res: string[] = [];
        if (this.requiredAttributs) {
          this.requiredAttributs.forEach((attrib) => {
            const value = attrib.split(".");
            if (value[0] == this.sectionName) {
              res.push(value[1])
            }
          })
        }
        return res;
      },

      requiredMissing(requiredAttributs: string[], value: string): boolean {
        return requiredAttributs.length > 0 && requiredAttributs.includes(value);;
      },

      readOnly (value: string): boolean {
        let res = false;
        if (!this.editTransaction.canUpdate) {
          return true;
        }
        if (this.readOnlyMap.size == 0) {
          this.readOnlyMap.set("ETABLISSEMENT_ID", false);
          this.readOnlyMap.set("AMOUNT", false);
          this.readOnlyMap.set("REFERENCE", false);
        }
        const readOnly = this.readOnlyMap.get(value);
        if (readOnly != undefined) {
          res = readOnly;
        }
        return res;
      },

      isDisplayed (value: string): boolean {
        let res = true;
        if (this.displayMap.size == 0) {
        const requiredAttributs = this.getRequiredAttributs();
          this.displayMap.set("ETABLISSEMENT_ID", true);
          this.displayMap.set("AMOUNT", true);
          this.displayMap.set("REFERENCE", true);
        }
        const display = this.displayMap.get(value);
        if (display != undefined) {
          res = display;
        }
        return res;
      },

      isRequired (value: string): boolean {
        let res = true;
        const requiredAttributs = this.getRequiredAttributs();
        if (this.requiredMap.size == 0) {
          this.requiredMap.set("ETABLISSEMENT_ID", true);
          this.requiredMap.set("AMOUNT", true);
          this.requiredMap.set("REFERENCE", true);
        }
        const required = this.requiredMap.get(value);
        if (required != undefined) {
          res = required;
        }
        return res;
      },

      picto (): string {
        return 'SectionPictoReceived' 
      },

      sectionSave (): void {
        return this.save();
      }
    }
  })
</script>
